import ImageGrid from '../ImageGrid/ImageGrid';
import SpainHeaderComp from '../Header/SpainHeaderComp'
import Section from '../Section'
import FormStyle1 from '../Form/FormStyle1';
import { Helmet } from 'react-helmet-async';
const GuaranteesSpainText = () => {
  return (

       <>
         <Helmet>
           <title>Garantias de Gestación Subrogada - Gestlife</title>
           <meta name="description" content="Garantias reales de la gestación subrogada con Gestlife." />
         </Helmet>
         
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        {/* Contenido principal a la izquierda */}
        <div style={styles.mainContent}>
          <h1 style={styles.mainHeading}>
            Garantias
          </h1>

          <h2 style={styles.subHeading}>
           Nada más y nada menos que 35 cosas nos diferencias de otras agencias:
          </h2>

          <div style={styles.textBlock}>
            <ol>
                <li>
              <h4 style={styles.subHeadingMinor}>
           PRECIO CERRADO EN LA MAYORÍA DE PROGRAMAS
             </h4>
             </li>
             <p>
                La mayoría de nuestros programas con donante de óvulos (lo que representa más del 80 % de nuestros procesos), son a precio cerrado sin sorpresas imprevisibles en nuestros programas ESTÁNDAR PLUS Y PREMIUM. De este modo, si por desgracia, hay que hacer múltiples FIVS, o múltiples transferencias, tú no has de pagar más. La clínica corre con estos gastos. 
             </p>

             <li>
              <h4 style={styles.subHeadingMinor}>
           LA VERDAD, TODA LA VERDAD Y NADA MÁS QUE LA VERDAD
             </h4>
             </li>
             <p>
                GESTLIFE adopta una postura de transparencia total con nuestros padres. El programa Infonow, del que hablaremos más adelante es buena prueba de ello durante el proceso, ya que permite saber AL MISMO TIEMPO QUE NOSOTROS, todo lo que sucede. Somos la única compañía en Europa que te ofrece este servicio de trasparencia. Pero ese compromiso de transparencia empieza mucho antes, en el asesoramiento. Te asesoraremos sobre TODOS los países donde se puede hacer un proceso de fecundación in vitro.. En cualquier caso, tu vienes a Gestlife para que te asesoremos, sobre todo, sobre lo bueno y lo malo, y así lo haremos, de modo que después, tú tengas todos los elementos para decidir, con conocimiento de causa.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           SOMOS VISIBLES, Y ESTAMOS IDENTIFICADOS
             </h4>
             </li>
             <p>
                Somos una agencia, pertenecientes al grupo estadounidense INVEST MEDICAL, con filiales propias en 11  países, de reconocido prestigio, con todos nuestros datos públicamente visibles. Muchas de las agencias no indican en sus páginas web que sociedades están detrás, ni siquiera cumplen con la Ley de Servicios de la Información (LSSICE) o el Reglamento Europeo de Protección de datos que obliga a publicar en la página web su número de identificación fiscal, su registro mercantil, domicilio y teléfonos. Parece como si esa información fuese secreta y no quieran que se sepa quién está detrás. Algunas, no tienen ni siquiera oficina, y reciben a los padres en el hall de algún hotel céntrico. Desconfíe de quien se esconde para que usted no sepa quiénes son realmente.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           SOMOS ABOGADOS
             </h4>
             </li>
             <p>
                No somos una simple "agencia "de gestación subrogada. Para empezar, la figura jurídica de la "agencia" no existe ni está reconocida en nuestro ordenamiento jurídico, por lo que a diferencia de un bufete de abogados que tiene obligaciones legales, seguro de responsabilidad civil etc.., las agencias no ofrecen garantía alguna. No hemos montado" una agencia " porque hemos visto un negocio. Ya existíamos antes de dedicarnos a los programas de fecundación in vitro,  y a otras técnicas   de reproducción asistida. Un despacho de abogados cumple siempre la ley, y tienes un referente en España a quien acudir, si algo va mal. El proceso que deseas emprender, posiblemente sea una de las cosas más importantes que harás en tu vida. ¿Vas a dejar entonces algo tan complejo en manos de amateurs, con muy buenas intenciones, pero sin estructuras propias ni conocimientos que garanticen el buen éxito del resultado? Nuestros servicios jurídicos han sido premiados el año pasado con la Medalla Europea al Mérito en el trabajo, y la estrella de Oro, en reconocimiento a nuestra profesionalidad.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           TRABAJAS CON UNA EMPRESA AMERICANA, con filiales en Europa
             </h4>
             </li>
             <p>
                Y nos paga en un paraíso fiscal o en las islas Seychelles, como hacen algunas agencias. GestLife cumple con la legislación vigente europea y estadounidense, verificada por el departamento de Compliance y te evita problemas futuros con hacienda Pública.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           NO EXPLOTACIÓN DE LAS  DONANTES
             </h4>
             </li>
             <p>
                Para Gestlife, el bienestar de la  donante de óvulos, en aquellos casos en que es precisa su participación, es la premisa número Uno, incluso por encima de los padres comitentes. Sin ella, tú no tendrías tu bebé. Gestlife se asegura de que la donante, esté cubierta por seguros médicos,  y sea debidamente atendida durante su estancia con nosotros. 
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           OFICINAS PROPIAS EN LOS PAÍSES. NO SOMOS INTERMEDIARIOS
             </h4>
             </li>
             <p>
                Tenemos oficinas propias en todos los países donde desarrollamos nuestros propios programas. De este modo tenemos un control desde la A a la Z, en el proceso, sin intermediarios. Este hecho se muestra decisivo en los periodos de dificultad, como durante la guerra, o la pandemia, periodo durante el cual las agencias sin oficinas propias no han podido dar servicio a sus padres, mientras Gestlife seguía haciéndolo.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           APLICACIÓN MÓVIL DE LA CLÍNICA
             </h4>
             </li>
             <p>
                GestLife es la única compañía que le ofrece una aplicación móvil que le informara sobre el estado de creación de los embriones, directamente con la clínica.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           UN ENCARGADO DE ASISTENCIA PARA TU EXPEDIENTE EN TU IDIOMA
             </h4>
             </li>
             <p>
                Se te designará un Encargado de Asistencia para el seguimiento y dirección de tu expediente, que habla tu idioma. Podrás hablar siempre que lo desees con él, en tu propio idioma, y él te mantendrá informado periódicamente por email, por teléfono y por WhatsApp, ante cualquier novedad y además podrás ver su expediente a través del programa INFONOW. Conocerás además al coordinador del país, siempre en tu idioma, persona jerárquicamente por encima del Encargado de Asistencia, a quien podrás dirigirte si consideras que algo no anda bien en tu proceso.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           SERVICIO INFONOW
             </h4>
             </li>
             <p>
                GestLife es la única compañía especializada en reproducción asistida que sigue una política de transparencia absoluta con sus padres. Todas las gestiones que realizamos para tu expediente, son anotadas en un programa informático que nos permite controlar los pasos a seguir. Gracias a un código personal que solo te da acceso a su expediente, podrás acceder las 24 horas del día, 365 días al año al mismo, y saber, al mismo tiempo que nosotros, todo lo que está sucediendo. Si no deseas entrar periódicamente en el programa, él mismo te mandará un e-mail por cada gestión realizada, siguiendo la política de transparencia absoluta.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           ACOMPAÑAMIENTO FÍSICO DURANTE LOS VIAJES
             </h4>
             </li>
             <p>
               Empleados nuestros en plantilla de la compañía (no colaboradores externos como traductores, taxistas etc.…) te recogerán en el aeropuerto (siempre en tu idioma) y te llevarán al hotel o apartamento donde se vaya a hospedar (dependiendo del país y programa que hayas escogido). Durante los días que, esté en el país, te acompañarán a todas las gestiones que se vayan a realizar para la consecución del proceso. Esta persona habla tu idioma y el idioma del país. Pero no es un simple traductor.
             </p>
             <p>
                Es un encargado de asistencia, capacitado para resolverle todos los problemas que puedan surgir. (No un simple traductor). No te damos un simple número de teléfono donde llamar si tienes problemas, para que solo entonces te asistan telefónicamente, o si es personalmente, tengas que pagar un suplemento del que no te hablaron nunca. Con nosotros nunca se sentirá nunca extranjero en un país extranjero.

             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           MÓVIL /INTERNET LOCAL
             </h4>
             </li>
             <p>
                La compañía te obsequiará durante tus desplazamientos a la ciudad de destino, con un móvil local y tarjeta SIM con Internet, de modo que puedas mantenerse en contacto gratuitamente tanto con la oficina en el país de destino como con sus familiares a través de internet en todo momento.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           SERVICIO INFONOW
             </h4>
             </li>
             <p>
                GestLife es la única compañía especializada en reproducción asistida que sigue una política de transparencia absoluta con sus padres. Todas las gestiones que realizamos para tu expediente, son anotadas en un programa informático que nos permite controlar los pasos a seguir. Gracias a un código personal que solo te da acceso a su expediente, podrás acceder las 24 horas del día, 365 días al año al mismo, y saber, al mismo tiempo que nosotros, todo lo que está sucediendo. Si no deseas entrar periódicamente en el programa, él mismo te mandará un e-mail por cada gestión realizada, siguiendo la política de transparencia absoluta.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           SERVICIO DE GUARDIA 24 HORAS/DÍA 365/DÍAS AL AÑO
             </h4>
             </li>
             <p>
                Cuando estás desplazado en el país de destino, además del acompañamiento personalizado, dispondrás del teléfono de las oficinas de GestLife en el país, y un teléfono de guardia 24 horas al día. Si te sucede algo, inmediatamente nos ocuparemos de ello.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           SEGUROS EXCLUSIVOS
             </h4>
             </li>
             <p>
                Gestlife cuenta con garantías exclusivas que cubren contingencias que ninguna otra compañía cubre: pérdida o deterioro de embriones durante el transporte, cambio de donante sin coste adicional en caso de punción blanca (sin óvulos), etc.… Sucesos terribles, que cuando suceden, además de conllevar un daño emocional inevitable, conllevan una importante pérdida económica de la que las agencias no te hablan. La cuestión es garantizarte que pase lo que pase, no haya sorpresas económicas. Si hablas con otras agencias, pregunta si quedan cubiertos estos sucesos.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           SEGURO DE ASISTENCIA EN VIAJE
             </h4>
             </li>
             <p>
                Durante sus viajes la compañía gestionará las distintas pólizas de asistencia en viaje que tienes, y no te acuerdas que tienes. Por ejemplo, en tu seguro de automóvil tienes cubierta la asistencia en el extranjero. Sucede lo mismo si cuentas con un seguro de una mutua (SANITAS, ADESLAS, DKV etc.), o tarjetas de Crédito. Parte del personal de GestLife procede de compañías de asistencia en viaje, especializadas en resolver los problemas graves 24 horas al día, en cualquier rincón del mundo. Si tuvieses cualquier contratiempo durante tu estancia, nosotros nos ocupamos de gestionar todo lo necesario con el seguro de asistencia, garantizando así tu bienestar.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           INFRAESTRUCTURA PROPIAS EN LOS PAÍSES DE DESTINO
             </h4>
             </li>
             <p>
                El resto de agencias que encontrarás, carecen de oficinas propias, con personal propio asegurado en la seguridad social del país, para poder prestarles un servicio de calidad. En el mejor de los casos utilizan los servicios de un corresponsal externo, pero sobre el cual no tienen poder alguno. Acuden a colaboradores externos, pero cuando surgen problemas o complicaciones, no están ahí, ni tienen personal preparado para resolver la contingencia in situ. Esto se ha demostrado de forma fehaciente durante la pandemia de COVID-19, especialmente durante los primeros meses de 2020, o durante la guerra de Ucrania (2022), donde quienes no tenían oficinas propias in situ, dejaron de la noche al día, de dar servicio a sus padres. GestLife cuenta con oficinas propias para la prestación de programas en GRECIA, COLOMBIA, MEXICO, ARMENIA KAZAJISTAN, USA, GEORGIA Y ALBANIA, con más de 190 empleados dedicados a ayudarte a hacer realidad tu sueño. Cuando tengas un problema, por pequeño que sea, nos tendrás ahí a tu lado.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           MÁS DE 190 EMPLEADOS DEDICADOS SÓLO A LA GESTACIÓN SUBROGADA RESPONSABLE
             </h4>
             </li>
             <p>
                Un proceso de reproducción asistida precisa de un equipo multidisciplinar en todos los países donde opera. Gestlife cuenta con más de 190 empleados, dedicados solo a hacer realidad su sueño, algo que ninguna otra agencia puede afirmar: abogados, pediatras, psicólogos, ginecólogos, embriólogos, encargados de asistencia, acompañantes, etc.. todos ellos EMPLEADOS de la compañía a plena dedicación, no colaborares externos.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           PERSONAL MULTILINGÜE EN TODAS LAS OFICINAS
             </h4>
             </li>
             <p>
                GestLife es la única compañía especializada en reproducción asistida que sigue una política de transparencia absoluta con sus padres. Todas las gestiones que realizamos para tu expediente, son anotadas en un programa informático que nos permite controlar los pasos a seguir. Gracias a un código personal que solo te da acceso a su expediente, podrás acceder las 24 horas del día, 365 días al año al mismo, y saber, al mismo tiempo que nosotros, todo lo que está sucediendo. Si no deseas entrar periódicamente en el programa, él mismo te mandará un e-mail por cada gestión realizada, siguiendo la política de transparencia absoluta.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           CÓDIGO DEONTOLÓGICO
             </h4>
             </li>
             <p>
                Gestlife Posee un código deontológico (que podrás consultar en nuestra web o en el dossier de servicios de cada país) de obligado cumplimiento por todo el personal. Practicamos la reproducción asistida, algo que solo se puede hacer si se cuenta con oficinas propias donde nuestros inspectores realizan una labor de seguimiento constante.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           PROCESOS TODOS LOS PAÍSES DONDE ES LEGAL
             </h4>
             </li>
             <p>
                No tenemos la necesidad de "venderte" un destino, como si Fuese la 8ª maravilla del mundo, porque no tenemos otro que ofrecerte. En GestLife trabajamos en todos los países donde la reproducción asistida para extranjeros es legal y te asesoramos sobre otros posibles destinos de los que hayas podido oír hablar.
            </p>
            <p>
                Nuestros honorarios son los mismos para todos los países, con lo que tienes la garantía de que te orientaremos sobre el que más te convenga a ti, no a la compañía. Otras empresas, con un solo destino, deben "cantarte" las loanzas de ese destino, e intentan desprestigiar a los otros destinos, para llevar al futuro padre a su terreno, el único que tienen. En GestLife solo tenemos un interés: ayudarte a escoger el destino que más le conviene por sus condiciones personales.

             </p>

               <li>
              <h4 style={styles.subHeadingMinor}>
           COLABORACIÓN CON CLÍNICAS NACIONALES
             </h4>
             </li>
             <p>
                En el caso de que tengas embriones (o material genético) ya creados en otras clínicas, y siempre cumpliendo la legislación vigente, nos encargaremos de ello para transportarlos al país de destino, siempre dentro de la legalidad vigente.
             </p>

              <li>
              <h4 style={styles.subHeadingMinor}>
           LA UNICA AGENCIA QUE ACEPTA TODO TIPO DE CASOS
             </h4>
             </li>
             <p>
                A menudo nos llaman padres que han sido rechazados por otras agencias, porque tienen HIV, o hepatitis, o por su baja calidad espermática, etc... La mayoría de agencias no se quieren “complicar la vida” con este tipo de padres. Pero en Gestlife nos apasionan los retos, y creemos firmemente en el derecho de toda persona a ser padre.
             </p>                  

              <li>
              <h4 style={styles.subHeadingMinor}>
           GESTLIFE ESTÁ AVALADA POR LA ASOCIACIÓN PADRES POR LA GESTACIÓN
             </h4>
             </li>
             <p>
                GESTLIFE es auditada cada dos meses por la ASOCIACION DE PADRES POR LA GESTACION ( www.padresporgestacion.org) , que cuenta con mas de 700 padres que han tenido hijos gracias a las técnicas de reproducción asistida.
             </p>    

              <li>
              <h4 style={styles.subHeadingMinor}>
           PROGRAMA PROPIO DE CAPTACIÓN DONANTES
             </h4>
             </li>
             <p>
               GestLife a través de la clínica perteneciente al grupo, realiza directamente, sin intermediarios la selección de las dos personas sin las cuales los programas no podrían llevarse a cabo: las gestantes, y las donantes de óvulos en los programas en que son necesarias.
             </p>  
             <p>
               Somos la única compañía en Europa que dispone de programa propio de captación de donantes. Se analiza su estado de salud, pero también todo su historial médico, el de sus familiares, sus antecedentes policiales y penales, y pasa una serie de entrevistas a cargo de nuestro psicólogo quien mediante una batería de TEST decide la idoneidad o no de la candidata.
             </p>   
             <p>
               Esto nos asegura una selección correcta y nos garantiza el éxito seguro en seleccionar la gestante y donantes más adecuadas para nuestras familias.
             </p>    

                <li>
              <h4 style={styles.subHeadingMinor}>
           PROGRAMA DE ACOMPAÑAMIENTOS DE LAS DONANTES
             </h4>
             </li>
             <p>
                En Gestlife además tiene una visión especial sobre el cuidado de las donantes.. No sólo se les paga una compensación económica, sino que intentamos que durante el proceso se encuentran acompañadas.
             </p>   

                <li>
              <h4 style={styles.subHeadingMinor}>
           INDEMNIZACIÓN LA DONANTE EN CASO DE DECESO O PÉRDIDA DE ÓRGANOS
             </h4>
             </li>
             <p>
                Los programas estándar plus y Premium cubren las posibles indemnizaciones (10.000 euros) a la familia de la donante en caso de deceso de éstas, o a ellas mismas en el caso de pérdida de órganos (perdida de útero en el parto, daño a los ovarios en la punción ovárica etc..). 
             </p>    

                <li>
              <h4 style={styles.subHeadingMinor}>
           CURSOS PREPARATORIOS PARA PAPAS PRIMERIZOS
             </h4>
             </li>
             <p>
                Durante el proceso, se imparten cursos preparatorios para el cuidado del bebé. Los cursos se realizan en directo, online, en multiconferencia, con una prestigiosa pediatra. Tiene un sentido eminentemente práctico y ha sido creado especialmente para padres por gestación subrogada.
             </p>  

                     <li>
              <h4 style={styles.subHeadingMinor}>
           TÚ NO TE ENCARGAS DE NADA
             </h4>
             </li>
             <p>
                Solo de aportar el material genético. Del resto se ocupa GestLife y sus filiales. Organización de los viajes, desarrollo del proceso, etc..
             </p>    

                     <li>
              <h4 style={styles.subHeadingMinor}>
           MÁS DE 500 PADRES FELICES CADA AÑO Y 2100 NIÑOS NACIDOS
             </h4>
             </li>
             <p>
                Nuestros hechos son nuestros mejores avales. Más de 500 padres hacen realidad cada año su sueño gracias a GestLife. Una mayoría silenciosa que hace poco ruido, pero que está ahí. Podemos ponerte en contacto con padres que ya han cumplido su sueño y que confiaron en nuestro grupo para hacerlo realidad.
             </p>    
               <p>
                Gracias a Gestlife, ya han nacido más de 2100 niños.
             </p> 
               <p>
                No todos los programas ofrecidos por GestLife, incluyen todas las garantías y servicios relacionados, dependiendo de la legislación y disponibilidad en cada país. Por favor consulta a tu Asesor de Familia las garantías y servicios ofrecidos en el programa que más te pueda interesar.
             </p> 

                     <li>
              <h4 style={styles.subHeadingMinor}>
           GESTLIFE TE ORGANIZA EL VIAJE Y TE ACOMPAÑA SI ES NECESARIO
             </h4>
             </li>
             <p>
               Para muchos padres, organizar un viaje es cosa fácil. Pero para otros, es algo complicado. Algunos aeropuertos, como el de Estambul, (uno de los mayores centros de conexión en Europa) son un verdadero laberinto para quienes no han viajado nunca, o han viajado pocas veces. Gestlife te organiza el viaje (reserva de billetes de avión, hotel o apartamento etc.). Incluso, a petición tuya si es necesario, se desplaza a tu ciudad para acompañarte tanto a la ida como a la vuelta.
             </p>    

               <li>
              <h4 style={styles.subHeadingMinor}>
           AYUDAS A LOS NIÑOS HUERFANOS DE KIEV UCRANIA
             </h4>
             </li>
             <p>
                Independientemente del país donde hagas tu proceso, Gestlife destina una parte de sus honorarios a la obra social de Gestlife, consistente en la ayuda a orfanatos de Kiev Ucrania, donde han quedado muchos niños no evacuados, y tienen importantes necesidades en un momento en que el país está concentrado en ganar una guerra. con tu programa estas ayudando a los niños huérfanos de Kiev, a través de la obra social. En diciembre de 2023, instalamos calefactores en el orfanato nº3 de Kiev, para evitar que pasasen frio durante el invierno (debido a los cortes de calefacción general causados por la guerra).
             </p>    

              <li>
              <h4 style={styles.subHeadingMinor}>
           GESTLIFE ES DE LAS POCAS AGENCIAS QUE REALIZAN LA TECNICA DE LOS TRES PADRES
             </h4>
             </li>
             <p>
                Gestlife es de las pocas agencias en el mundo que ofrece a las parejas heterosexuales, la técnica del TRASPLANTE PRONUCLEAR, mas conocida por la técnica de los tres padres. Hasta hace poco, a menudo, la calidad de los ovocitos de la madre comitente, obligaban a la pareja a tener que recurrir a una donante de óvulos. Con el trasplante pronuclear, se utiliza el Adn de los dos padres comitentes, en el ovulo de una donante, de modo que ésta no aporta material genético al bebe. De este modo Gestlife se sitúa como Pionera entre las agencias en esta técnica revolucionaria.
             </p>                  

              <li>
              <h4 style={styles.subHeadingMinor}>
           LA MAYORÍA DE PROGRAMAS EN GESTLIFE INCLUYEN LA PGD DE 24 CROMOSOMAS
             </h4>
             </li>
             <p>
                La PGD de 24 cromosomas, (diagnóstico preimplantacional genético), permite descartar cualquier embrión que pueda llevar una enfermedad genética. Así, descartamos cientos de enfermedades posibles, asegurándonos que cada embrión implantado era el mejor, lo que aumenta la tasa de éxito de embarazo al primer intento. A diferencia del resto de agencias, la mayoría de programas de Gestlife incluyen este test.
             </p> 

              <li>
              <h4 style={styles.subHeadingMinor}>
           TODA UNA ESTRUCTURA EN TU IDIOMA
             </h4>
             </li>
             <p>
              Algunas agencias se preocupan de tener un asesor, en la parte informativa del programa, que habla tu idioma. Pero una vez empieza el proceso, con un poco de suerte tendrás un traductor a ratos. En Gestlife somos más de 175 personas porque nuestros equipos hablan 9 idiomas. Podrás hablar en tu idioma con:
                <ul>
                <li> Tu acompañante (quien te recoger y te lleva a todas partes)</li>
                <li> Tu encargado de asistencia, que es quien gestiona tu expediente todo el tiempo.</li>
                <li>  El coordinador de tu país. Esta persona es el superior del encargado de asistencia, por si deseas hablar con alguien </li>jerárquicamente superior.
                </ul>
             </p>                                                                                  
            </ol>

            
           
          </div>
        </div>

        {/* Formulario a la derecha, sin envoltorio extra ni sticky
        <div style={styles.formColumn}>
          <FormStyle1 />
        </div> */}
      </div>
    </div>
     </>
  );
};

export default GuaranteesSpainText;

// --- Estilos para la versión de escritorio ---
const styles = {
  container: {
    backgroundColor: 'white',
    padding: '2rem',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    fontFamily: 'Arial, sans-serif', 
    paddingLeft: '4rem',
    paddingRight: '4rem',
  },
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr', // Por defecto, una columna para móviles
    gap: '4rem', 
    maxWidth: '1200px', 
    margin: '0 auto', 
    // La media query para desktop se simula con JS debajo
    // Idealmente, esto iría en CSS externo o con una librería CSS-in-JS.
    '@media (min-width: 1024px)': { 
      gridTemplateColumns: '2fr 1fr', 
    },
  },
  mainContent: {
    marginBottom: '2rem', // Mantener espacio para móviles/tablets
    '@media (min-width: 1024px)': {
      marginBottom: '0', // Eliminar el margen si hay dos columnas
    },
  },
  mainHeading: {
    fontSize: '2.8rem', 
    fontWeight: 'bold',
    color: '#ec4899', 
    lineHeight: '1.2',
    marginBottom: '1.5rem', 
  },
  subHeading: {
    fontSize: '1.8rem', 
    fontWeight: '700', 
    color: '#f472b6', 
    marginTop: '2.5rem', 
    marginBottom: '1.5rem', 
    borderBottom: '2px solid #f9a8d4', 
    paddingBottom: '0.5rem',
  },
  subHeadingMinor: { 
    fontSize: '1.3rem', 
    fontWeight: '600', 
    color: '#f472b6', 
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  textBlock: {
    color: '#4b5563',
    lineHeight: '1.7', 
    fontSize: '1.05rem', 
    marginTop: '1.5rem',
  },
  paragraph: {
    marginBottom: '1rem', 
  },
  highlightedParagraph: {
    fontWeight: '700', 
    color: '#1f2937', 
    textDecoration: 'underline',
    textDecorationColor: '#f9a8d4', 
    marginBottom: '1.2rem', 
    fontSize: '1.1rem', 
  },
  formColumn: {
    // Ya no necesita position: 'relative' si el formulario no es sticky
    // El formulario FormStyle1 controlará sus propios estilos internos
  },
  // Eliminamos el objeto stickyForm, ya no es necesario
};
